import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function SearchEngineMarketing() {
  return (
    <>
      <Helmet>
        <title>Best SEM Services Company in Ajman, Sharjah, Fujairah, Dubai, UAE</title>
        <meta name="description" content={"As the best SEM services company in Dubai, we create data-driven search engine marketing campaigns that maximise traffic, leads, and ROI."} />
        <meta name="keywords" content={"Best SEM Services Company in Dubai,Best SEM Services Company in uae,Best SEM Services Company in ajman,Best SEM Services Company in sharjah,Best SEM Services Company in Abu Dhabi,Best SEM Services Company in fujairah "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/search-engine-marketing"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Search Engine Marketing</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Search Engine Marketing</li>
      </ul>
    </div>
  </div>
  <section style={{width: '100%', height: 200}}>
    <h1 style={{fontSize: 24, marginTop: 40, marginLeft: 70}}>Best SEM Services Company in Abu Dhabi, Ajman, Sharjah, Fujairah, Dubai, UAE</h1>
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default SearchEngineMarketing;
